import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { Popover, Box, Typography, Stack, Collapse } from '@mui/material';
import { Circle, ExpandMore } from '@mui/icons-material';
import { LegendIconButton } from '../style/map_components';
import { CHRONOLOGY_LEVEL_COLOR, CHRONOLOGY_LEVEL_LABEL } from '../const/color';

const MapChronologyLegendIcon = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [legendOpen, setLegendOpen] = useState(false);
    const [chronologyOpen, setChronologyOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        console.log('handleClose')
        setAnchorEl(null);
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    const legendItems = [
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_8, label: CHRONOLOGY_LEVEL_LABEL.LEVER_8 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_9, label: CHRONOLOGY_LEVEL_LABEL.LEVER_9 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_7, label: CHRONOLOGY_LEVEL_LABEL.LEVER_7 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_5, label: CHRONOLOGY_LEVEL_LABEL.LEVER_5 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_6, label: CHRONOLOGY_LEVEL_LABEL.LEVER_6 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_1, label: CHRONOLOGY_LEVEL_LABEL.LEVER_1 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_4, label: CHRONOLOGY_LEVEL_LABEL.LEVER_4 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_3, label: CHRONOLOGY_LEVEL_LABEL.LEVER_3 },
        { color: CHRONOLOGY_LEVEL_COLOR.LEVER_2, label: CHRONOLOGY_LEVEL_LABEL.LEVER_2 }
    ];

    const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                mb: 0.5,
                ...sx
            }}
            onClick={toggle}
        >
            <ExpandMore
                sx={{
                    transform: expanded ? 'rotate(180deg)' : 'rotate(-90deg)',
                    transition: 'transform 0.2s',
                    fontSize: 16,
                    mr: 0.5
                }}
            />
            <Typography sx={{ fontSize: '0.75rem' }}>{label}</Typography>
        </Box>
    );

    return (
        <>
            <LegendIconButton
                onClick={handleClick}
            >
                <InfoIcon sx={iconStyle} />
            </LegendIconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, maxWidth: 200 }}>
                    {/* タイトル部：クリックで開閉 */}
                    <ExpandableHeader
                        label="凡例"
                        expanded={legendOpen}
                        toggle={() => setLegendOpen(!legendOpen)}
                    />
                    <Collapse in={legendOpen}>
                        <Box sx={{ pl: 2 }}>
                            {/* サブセクション */}
                            <ExpandableHeader
                                label="クロノロジー"
                                expanded={chronologyOpen}
                                toggle={() => setChronologyOpen(!chronologyOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={chronologyOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {legendItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>{item.label}</Typography>
                                            <Typography sx={{ fontSize: "10px", pl: 1, ml: '15px' }}>{item.threshold}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                    </Collapse>
                </Box>
            </Popover>
        </>
    );
};
export default MapChronologyLegendIcon;